import React, { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import close from 'browser/assets/icons/close-hint.svg';
import cursorIcon from 'browser/assets/icons/cursor-icon.svg';
import triangleRight from 'browser/assets/icons/triangle-right.svg';

const leftToRight = keyframes`
from {
  transform: translate(0, -50%);
}
30% {
  transform: translate(0, -50%);
}
40% {
  transform: translate(5%, -50%);
}
50% {
  transform: translate(0, -50%);
}
60% {
  transform: translate(5%, -50%);
}
70% {
  transform: translate(0, -50%);
}
to {
  transform: translate(0, -50%);
}
`;

const HintWrapper = styled.div`
  position: absolute;
  top: ${({ chooseBuilding }) => (chooseBuilding ? '70%' : '50%')};
  left: ${({ chooseBuilding }) => (chooseBuilding ? '22%' : '15%')};
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  width: 220px;
  height: 90px;
  padding: 15px;
  background-color: #fff;
  border-radius: 12px;
  visibility: visible;
  opacity: 1;
  cursor: pointer;
  pointer-events: all;
  animation: ${leftToRight} alternate 5s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  z-index: 2;
  ${({ visible }) =>
    !visible &&
    css`
      visibility: hidden;
    `}

  @media (max-width: 440px) {
    display: none;
  }
`;

const CursorIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  width: 70px;
  background-color: #f8eccb;
  border-radius: 50%;
  margin-right: 10px;

  img {
    width: 35px;
    height: 35px;
  }
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 1.1;
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;

  img {
    width: 10px;
    height: 10px;
  }
`;

const ArrowRight = styled.div`
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translate(100%, -50%);

  img {
    width: 20px;
    height: 20px;
  }
`;

const Hint = ({ chooseBuilding }) => {
  const [isVisible, setIsVisible] = useState(true);

  return (
    <HintWrapper
      visible={isVisible}
      onClick={() => setIsVisible(false)}
      chooseBuilding={chooseBuilding}
    >
      <CursorIcon>
        <img src={cursorIcon} alt="cursor-icon" />
      </CursorIcon>
      <Text>
        Kliknij <br /> i wybierz <br /> {chooseBuilding ? 'budynek' : 'piętro'}
      </Text>
      <CloseIcon>
        <img src={close} alt="close" />
      </CloseIcon>
      <ArrowRight>
        <img src={triangleRight} alt="arrow-right" />
      </ArrowRight>
    </HintWrapper>
  );
};

export default Hint;
